import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../../jsonapi-provider';
import { type ServiceType } from '../../types';
import { LocalDate } from '../../utils/local-date';
import type SiteInvoice from '../site-invoice';

@JsonApiResource({
  type: 'price-adjustment',
})
export default class PriceAdjustment extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) serviceDate: LocalDate;
  @JsonApiProperty({ resolver: Number }) amount: number;
  @JsonApiProperty({ type: 'string' }) note: string;
  @JsonApiProperty({ type: 'boolean', readOnly: true }) isApplied: boolean;
  @JsonApiProperty({ type: 'boolean', readOnly: true }) isUpdatable: boolean;
  @JsonApiProperty({ type: 'boolean', readOnly: true }) isDeletable: boolean;
  serviceType: ServiceType = 'C1';
  @JsonApiRelationship('site-invoice') siteInvoice: SiteInvoice | null | undefined;

  constructor(
    id: PriceAdjustment['id'] = undefined,
    serviceDate: PriceAdjustment['serviceDate'] = new LocalDate(),
    amount: PriceAdjustment['amount'] = 1.0,
    note: PriceAdjustment['note'] = '',
    serviceType: PriceAdjustment['serviceType'] = 'C1',
    public type: 'CHARGE' | 'CREDIT' = 'CHARGE',
    isApplied: PriceAdjustment['isApplied'] = false,
    siteInvoice: PriceAdjustment['siteInvoice'] = undefined,
    isUpdatable: PriceAdjustment['isUpdatable'] = true,
    isDeletable: PriceAdjustment['isDeletable'] = true
  ) {
    super();
    this.id = id;
    this.serviceDate = serviceDate;
    this.amount = amount;
    this.note = note;
    this.isApplied = isApplied;
    this.siteInvoice = siteInvoice;
    this.isUpdatable = isUpdatable;
    this.isDeletable = isDeletable;
    this.serviceType = serviceType;
  }
}
